module.exports = __webpack_public_path__ + "img/1.cb76dd08.png";